import ActionTypes from "./actionTypes";
import { Individual } from "../../../models/Contact/Individual/Individual";
import { getAppStore } from "../../store";
import { Company } from "../../../models/Contact/Company/Company";
import { Trust } from "../../../models/Contact/Trust/Trust";

export class IndividualStoreActions {
    static loadingIndividuals(loading: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADING_INDIVIDUALS, payload: loading });
    }
    static setIndividualLoaded(state: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADED_INDIVIDUALS, payload: state });
    }
    static saveIndividuals(indv: Individual[]) {
        getAppStore().dispatch({ type: ActionTypes.SAVE_INDIVIDUALS, payload: indv });
    }
    static removeIndividual(individual: Individual) {
        getAppStore().dispatch({ type: ActionTypes.REMOVE_INDIVIDUAL, payload: individual });
    }
    static getIndividuals() {
        return getAppStore().getState().contacts.individuals;
    }
    static addOrUpdateToIndividuals(individual: Individual) {
        let individuals = IndividualStoreActions.getIndividuals();
        if (individuals.some((t) => t.data.attrs._id === individual.id)) {
            individuals = individuals.map((t) => {
                if (t.data.attrs._id === individual.id) {
                    return t.updateIndividual(individual);
                }
                return t;
            });
        } else {
            individuals = [individual, ...individuals];
        }
        IndividualStoreActions.saveIndividuals(individuals);
    }
}

export class CompanyStoreActions {
    static loadingCompanies(loading: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADING_COMPANIES, payload: loading });
    }
    static setCompanyLoaded(state: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADED_COMPANIES, payload: state });
    }
    static saveCompanies(company: Company[]) {
        getAppStore().dispatch({ type: ActionTypes.SAVE_COMPANIES, payload: company });
    }
    static removeCompany(company: Company) {
        getAppStore().dispatch({ type: ActionTypes.REMOVE_COMPANY, payload: company });
    }
    static getCompanies() {
        return getAppStore().getState().contacts.companies;
    }
    static addOrUpdateToCompanies(company: Company) {
        let companies = CompanyStoreActions.getCompanies();
        if (companies.some((t) => t.data.attrs._id === company.id)) {
            companies = companies.map((t) => {
                if (t.data.attrs._id === company.id) {
                    return t.updateCompany(company);
                }
                return t;
            });
        } else {
            companies = [company, ...companies];
        }
        CompanyStoreActions.saveCompanies(companies);
    }
}

export class TrustStoreActions {
    static loadingTrusts(loading: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADING_TRUSTS, payload: loading });
    }
    static setTrustLoaded(state: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADED_TRUSTS, payload: state });
    }
    static saveTrusts(trust: Trust[]) {
        getAppStore().dispatch({ type: ActionTypes.SAVE_TRUSTS, payload: trust });
    }
    static removeTrust(trust: Trust) {
        getAppStore().dispatch({ type: ActionTypes.REMOVE_TRUST, payload: trust });
    }
    static getTrusts() {
        return getAppStore().getState().contacts.trusts;
    }
    static addOrUpdateToTrusts(trust: Trust) {
        let trusts = TrustStoreActions.getTrusts();
        if (trusts.some((t) => t.data.attrs._id === trust.id)) {
            trusts = trusts.map((t) => {
                if (t.data.attrs._id === trust.id) {
                    return t.updateTrust(trust);
                }
                return t;
            });
        } else {
            trusts = [trust, ...trusts];
        }
        TrustStoreActions.saveTrusts(trusts);
    }
}
